import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react';
import { initAnalytics, posthog, track, EVENTS, registerSuperPropsOnce, captureException } from './analytics/analytics';
import { firstTouchAttribution } from './analytics/attribution';
import AppRecoveryBoundary, { RecoveryScreen } from './components/AppRecoveryBoundary';

// Initialise PostHog once, before render. No-ops if REACT_APP_POSTHOG_KEY is unset.
const isLibrary = /^\/(learn|tools|resources)(\/|$)/.test(window.location.pathname);
initAnalytics({ privateWritingSurface: isLibrary });

// This lives in the entry bundle, so a failed lazy chunk still has a UI.
function bootstrapFailed(error) {
  captureException(error, { area: 'app_bootstrap' });
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<RecoveryScreen error={error} onRetry={() => window.location.reload()} />);
}

// Public library pages have their own light, prerendered entry point.
// Keep the authenticated application and its API calls out of the reading path.
if (isLibrary) {
  registerSuperPropsOnce(firstTouchAttribution());
  import('./library/LibraryRoot').then(({ mountLibrary }) => mountLibrary()).catch(bootstrapFailed);
} else {
  import('./App').then(({ default: App }) => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <AppRecoveryBoundary><PostHogProvider client={posthog}><App /></PostHogProvider></AppRecoveryBoundary>
      </React.StrictMode>
    );
  }).catch(bootstrapFailed);
}

// Forward Core Web Vitals (LCP, CLS, FCP, TTFB, FID) into PostHog so we can
// track real-user performance per route — especially on the SEO landing pages.
reportWebVitals((metric) => {
  track(EVENTS.WEB_VITAL, {
    metric_name: metric.name,
    value: metric.value,
    delta: metric.delta,
    rating: metric.rating, // present in web-vitals v3+; undefined on v2
    metric_id: metric.id,
    route: window.location.pathname,
  });
});
